<!-- 设置分组 -->
<template>
  <div class="batchGiftSet cus-modal" v-loading="loading">
    <OmsForm :form-config="formConfig" />
    <OmsButton class="modal-footer" :btn-config="btnConfig" /> 
  </div>
</template>
<script>
  import batchGiftSet from '@/js/modal/promotionCenter/batchGiftSet';
  export default batchGiftSet;
</script>
<style lang="less" scoped>
// @import "~@/css/modal/promotionCenter/setGroup.less";
</style>